export { default } from './DivBlockStyle'
